import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Eyebrow,
  Pill,
} from '@/shared/components';
import type { ChannexWebhookEventResponse } from '@/shared/api';
import { formatDateTime } from '@/shared/lib/format';
import { formatRaw, statusLabel, statusPillVariant } from './helpers';

interface WebhookEventDetailDialogProps {
  event: ChannexWebhookEventResponse | null;
  onOpenChange: (open: boolean) => void;
}

export function WebhookEventDetailDialog({ event, onOpenChange }: WebhookEventDetailDialogProps) {
  return (
    <Dialog open={event !== null} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle className="wrap-break-word">
            {event?.eventType ?? 'Meldung'}{' '}
            <span className="text-ink-soft font-mono text-sm">{event?.liveFeedEventId}</span>
          </DialogTitle>
          <DialogDescription>
            {event && (
              <>
                Empfangen: {formatDateTime(event.receivedAt)}
                {event.processedAt && <> · Verarbeitet: {formatDateTime(event.processedAt)}</>}
                {' · Zustand: '}
                <Pill variant={statusPillVariant(event.status)} size="sm">
                  {statusLabel(event.status)}
                </Pill>
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          {event?.error && (
            <div className="bg-sealwax/10 border-sealwax/30 mb-4 rounded-md border p-4">
              <Eyebrow variant="sub" className="text-sealwax mb-2">
                Fehler
              </Eyebrow>
              <p className="text-ink font-mono text-xs leading-relaxed">{event.error}</p>
            </div>
          )}
          <Eyebrow variant="sub" className="mb-2">
            Unveränderter Inhalt (SHA-256: {event?.payloadHash.slice(0, 16)}…)
          </Eyebrow>
          {/* Vorher lag der Inhalt auf dem Navy-Alias (`--color-bg-dark`) mit ink-soft-Text
              (`--color-fg-dim`): rund 1,3:1 auf der dunklen Fläche und praktisch nicht zu lesen.
              Ein Rohdatum, das man nicht lesen kann, ist der einzige Zweck dieses Dialogs. */}
          <pre className="bg-card-alt border-line text-ink max-h-96 overflow-auto rounded-md border p-4 font-mono text-xs leading-relaxed">
            {event ? formatRaw(event.rawJson) : ''}
          </pre>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
